import React, { useState, useEffect, useRef } from 'react';
import './css/Exports.css';
import BannerImage from './BannerImage.jsx';


const FAQ_DATA = [
  {
    q: "What products does Walnut Industries manufacture?",
    a: "We manufacture a wide range of automotive fasteners and two-wheeler spare parts, including nuts & bolts, screws, washers, springs, chain adjusters, wheel axles, side stands, gear lever assemblies, brake rod assemblies, and customized fastening solutions. With over 2,000 products, we offer one of the industry's most comprehensive portfolios."
  },
  {
    q: "How long has Walnut Industries been serving the automotive industry?",
    a: "Established in 1980 in Ludhiana, Punjab, Walnut Industries has more than 46 years of experience in manufacturing precision-engineered automotive fasteners and components. Our decades of expertise have made us a trusted partner for customers across India and international markets."
  },
  {
    q: "Why choose Walnut Industries?",
    a: "Walnut Industries is known for its uncompromising quality, precision engineering, fast and reliable dispatches, and customer-first approach. We serve customers across more than 25 states in India and export worldwide, delivering high-quality products that meet the demanding requirements of the automotive industry."
  }
];


export default function Exports() {
  const [openFaqIndex, setOpenFaqIndex] = useState(null);

  // ── MAP REFS ──
  const mapContainerRef = useRef(null);
  const mapImageRef = useRef(null);

  const toggleFaq = (index) => {
    setOpenFaqIndex(prevIndex => prevIndex === index ? null : index);
  };

  // ── DRAGGABLE MAP LOGIC ──
  useEffect(() => {
    const container = mapContainerRef.current;
    const img = mapImageRef.current;
    if (!container || !img) return;

    let isDragging = false;
    let startX, startY;
    let imgX = 0, imgY = 0;

    const clamp = (val, min, max) => Math.min(Math.max(val, min), max);

    const getMaxOffset = () => ({
      maxX: -(img.offsetWidth - container.offsetWidth),
      maxY: -(img.offsetHeight - container.offsetHeight),
    });

    // Mouse Events
    const onMouseDown = (e) => {
      isDragging = true;
      startX = e.clientX - imgX;
      startY = e.clientY - imgY;
      container.style.cursor = 'grabbing';
      img.style.cursor = 'grabbing';
      e.preventDefault();
    };

    const onMouseMove = (e) => {
      if (!isDragging) return;
      const { maxX, maxY } = getMaxOffset();
      imgX = clamp(e.clientX - startX, maxX, 0);
      imgY = clamp(e.clientY - startY, maxY, 0);
      img.style.left = `${imgX}px`;
      img.style.top = `${imgY}px`;
    };

    const onMouseUp = () => {
      isDragging = false;
      container.style.cursor = 'grab';
      img.style.cursor = 'grab';
    };

    // Touch Events
    const onTouchStart = (e) => {
      const touch = e.touches[0];
      isDragging = true;
      startX = touch.clientX - imgX;
      startY = touch.clientY - imgY;
    };

    const onTouchMove = (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const touch = e.touches[0];
      const { maxX, maxY } = getMaxOffset();
      imgX = clamp(touch.clientX - startX, maxX, 0);
      imgY = clamp(touch.clientY - startY, maxY, 0);
      img.style.left = `${imgX}px`;
      img.style.top = `${imgY}px`;
    };

    const onTouchEnd = () => { isDragging = false; };

    // Attach
    container.addEventListener('mousedown', onMouseDown);
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
    container.addEventListener('touchstart', onTouchStart, { passive: false });
    container.addEventListener('touchmove', onTouchMove, { passive: false });
    container.addEventListener('touchend', onTouchEnd);

    // Cleanup
    return () => {
      container.removeEventListener('mousedown', onMouseDown);
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
      container.removeEventListener('touchstart', onTouchStart);
      container.removeEventListener('touchmove', onTouchMove);
      container.removeEventListener('touchend', onTouchEnd);
    };
  }, []);

  return (
    <div className="exports-container-root">

      {/* EXPORTS HERO */}
      <section
        className="products-hero-banner"
        style={{ width: '100%', backgroundColor: '#0E0E0E', overflow: 'hidden' }}
      >
        <BannerImage
          src="/banners/EXPORTS PAGE WALNUT.png"
          alt="Walnut Industries Fasteners Catalog Showcase"
          style={{ width: '100%' }}
          imageStyle={{ height: 'auto' }}
          fallbackText="Exports Banner"
        />
      </section>

      {/* TRUST STRIP */}
      <section className="trust-strip">
        <div className="ts-item"><span className="ts-icon">✓</span> ISO 9001:2015 Audited</div>
        <div className="ts-item"><span className="ts-icon">✓</span> SGS Material Compliance</div>
        <div className="ts-item"><span className="ts-icon">✓</span> Custom Port Clearing Security</div>
        <div className="ts-item"><span className="ts-icon">✓</span> Multi-modal Freight Network</div>
        <div className="ts-quote">
          <span className="qm">"</span>
          <p>Zero Freight Latency Framework Execution.</p>
        </div>
      </section>

      {/* COMPLIANCE CERTIFICATIONS
      <section className="certified-section">
        <div className="sec-head">
          <h2>INTERNATIONAL STRUCTURAL CERTIFICATIONS</h2>
        </div>
        <div className="certified-grid">
          <div className="cert-card">
            <div className="cert-icon">📜</div>
            <h4 className="cert-name">IATF 16949 Compliance</h4>
            <p className="cert-desc">Aligning strictly to premium global automotive supply chain execution rules.</p>
          </div>
          <div className="cert-card">
            <div className="cert-icon">🛡</div>
            <h4 className="cert-name">CE Structural Approval</h4>
            <p className="cert-desc">Ensuring full technical configuration integration with European economic standards.</p>
          </div>
          <div className="cert-card">
            <div className="cert-icon">🌍</div>
            <h4 className="cert-name">ISO 14001 Standards</h4>
            <p className="cert-desc">Applying environment-friendly metrics throughout metallurgical casting operations.</p>
          </div>
          <div className="cert-card">
            <div className="cert-icon">⚓</div>
            <h4 className="cert-name">Authorized Economic Operator</h4>
            <p className="cert-desc">Accelerated customs processing clearances across high-priority port lanes.</p>
          </div>
        </div>
      </section> */}

      {/* DISTRIBUTION REACH MAP SECTOR */}
      <section className="world-section">
        <div className="sec-head">
          <h2>TARGET EXPORT OPERATIONS</h2>
        </div>

        {/* India — Domestic */}
        <div style={{ maxWidth: '1100px', margin: '0 auto 24px', padding: '0 40px' }}>
          <div style={{
            fontFamily: 'var(--font-head)',
            fontSize: '13px', fontWeight: '700',
            color: 'var(--red)', letterSpacing: '2px',
            textTransform: 'uppercase', marginBottom: '12px',
            display: 'flex', alignItems: 'center', gap: '10px'
          }}>
            <span style={{ display: 'inline-block', width: '20px', height: '2px', background: 'var(--red)' }}></span>
            Domestic — India
          </div>
          <div className="country-pill" style={{ display: 'inline-flex', padding: '10px 20px' }}>
            <span className="flag">🇮🇳</span>
            <span>All Over India
              
            </span>
          </div>
        </div>

        {/* International Exports */}
        <div style={{ maxWidth: '1100px', margin: '0 auto 40px', padding: '0 40px' }}>
          <div style={{
            fontFamily: 'var(--font-head)',
            fontSize: '13px', fontWeight: '700',
            color: 'var(--red)', letterSpacing: '2px',
            textTransform: 'uppercase', marginBottom: '12px',
            display: 'flex', alignItems: 'center', gap: '10px'
          }}>
            <span style={{ display: 'inline-block', width: '20px', height: '2px', background: 'var(--red)' }}></span>
            International Exports
          </div>
          <div className="countries-grid">
            {[
              { flag: '🇧🇩', country: 'Bangladesh' },
              { flag: '🇳🇵', country: 'Nepal' },
              { flag: '🇱🇰', country: 'Sri Lanka' },
              { flag: '🇬🇧', country: 'England' },
              { flag: '🇨🇴', country: 'Colombia' },
              { flag: '🇧🇷', country: 'Brazil' },
              { flag: '🇵🇪', country: 'Peru' },
              { flag: '🇲🇽', country: 'Mexico' },
              { flag: '🌍', country: 'African Continent' },
            ].map((item, idx) => (
              <div key={idx} className="country-pill">
                <span className="flag">{item.flag}</span>
                <span>{item.country}</span>
              </div>
            ))}
          </div>
        </div>

        {/* ── DRAGGABLE MAP ── */}
        <div className='map-drag' style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <div
            ref={mapContainerRef}
            style={{
              width: '100%',
              height: '420px',
              overflow: 'hidden',
              borderRadius: '8px',
              border: '1px solid #2a2a2a',
              cursor: 'grab',
              position: 'relative',
              background: '#0d0d0d',
              userSelect: 'none',
            }}
          >
            <img
              ref={mapImageRef}
              src="/resources/walnut-map.png"
              alt="Export Map"
              draggable={false}
              style={{
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: 'auto',
                height: 'auto',      
                minWidth: '200%',   
                minHeight: '200%',  
                cursor: 'grab',
                transition: 'none',
              }}
            />

            {/* Overlay label */}
            <div style={{
              position: 'absolute',
              bottom: '14px', left: '14px',
              background: 'rgba(0,0,0,0.6)',
              color: '#fff',
              fontFamily: 'var(--font-head)',
              fontSize: '11px', fontWeight: '700',
              letterSpacing: '1.5px', textTransform: 'uppercase',
              padding: '6px 12px', borderRadius: '4px',
              borderLeft: '2px solid #D0021B',
              pointerEvents: 'none',
            }}>
              Drag to explore · Active Transit Portfolio
            </div>
          </div>
        </div>

      </section>

      {/* FAQ LOGISTICS ACCORDION */}
      <section className="faq-section">
        <div className="sec-head">
          <h2>LOGISTICS & COMPLIANCE FAQ</h2>
        </div>
        <div className="faq-wrapper">
          {FAQ_DATA.map((item, index) => {
            const isOpen = openFaqIndex === index;
            return (
              <div key={index} className={`faq-item ${isOpen ? 'open' : ''}`}>
                <div className="faq-q" onClick={() => toggleFaq(index)}>
                  <span>
                    <span className="faq-num">0{index + 1}.</span>
                    {item.q}
                  </span>
                  <span className="faq-icon">{isOpen ? '−' : '+'}</span>
                </div>
                <div
                  className="faq-a"
                  style={{
                    maxHeight: isOpen ? '200px' : '0',
                    paddingBottom: isOpen ? '18px' : '0'
                  }}
                >
                  {item.a}
                </div>
              </div>
            );
          })}
        </div>
      </section>

    </div>
  );
}